<template>
  <div class="seriesClass">
    <el-card>
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/goodsInfo' }">商品管理</el-breadcrumb-item>
        <el-breadcrumb-item>{{ $route.query.type == 'add' ? '新增系列课' : '编辑系列课' }}</el-breadcrumb-item>
      </el-breadcrumb>
    </el-card>
    <el-card class="box-card" style="margin-top: 20px">
      <el-form ref="addForm" :model="addForm" :label-width="formLabelWidth" :rules="addFormRules">
        <el-row>
          <el-col :sm="24" :md="24" :lg="16">
            <el-form-item label="系列课名称" prop="name">
              <el-input v-model="addForm.name" placeholder="请输入系列课名称" auto-complete="off" maxlength="20"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :sm="24" :md="24" :lg="16">
            <el-form-item label="所属科目" prop="subjectId">
              <!-- <el-cascader style="width: 100%" clearable :disabled="$route.query.type != 'add'" v-model="courseIds" :empty="addForm.subjectCourseName" :show-all-levels="false" :props="subjectTreeProps" placeholder="请输入所属科目" :options="subjectTreeList" @change="subjectSearchChange"></el-cascader> -->
              <el-cascader style="width: 100%" clearable :disabled="$route.query.type != 'add'" v-model="addForm.subjectId" :show-all-levels="false" :props="subjectTreeProps" placeholder="请输入所属科目" :options="subjectTreeList" @change="subjectSearchChange"></el-cascader>
            </el-form-item>
          </el-col>
        </el-row>
        <el-button style="margin-bottom:15px" type="primary" size="mini" @click="addSeries">+ 系列</el-button>
        <el-row v-for="(item, index) in addForm.seriesList" :key="index">
          <el-col :sm="8" :md="8" :lg="8">
            <el-form-item :label="'商品' + (index + 1)">
              <el-tag closable type="success" @click="openGoodsModal(index)" @close="deleteSeries(index)">
                {{ item.designName || '请选择商品' }}
              </el-tag>
            </el-form-item>
          </el-col>
          <el-col :sm="8" :md="8" :lg="8" v-if="item.goodsId">
            <el-form-item label="课程名">
              <el-input v-model="item.name" placeholder="请输入系列课名称" auto-complete="off" maxlength="25"></el-input>
            </el-form-item>
          </el-col>
          <el-col :sm="8" :md="8" :lg="8" v-if="item.goodsId">
            <el-form-item label="班次">
              <el-input v-model="item.classes" placeholder="请输入系列课名称" auto-complete="off" maxlength="25"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div class="btnCenter">
        <el-button type="primary" @click="addConfirm">确 定</el-button>
      </div>
    </el-card>
    <el-dialog :title="'添加推荐商品'" :visible.sync="addFormVisible" width="60%" left :close-on-click-modal="false">
      <el-form :label-width="formLabelWidth">
        <div>
          <el-row :span="24">
            <el-col :sm="5" :md="5" :lg="5">
              <el-form-item label="所属分类" label-width="80px" prop="pid">
                <el-cascader @change="subjectChange" v-model="searchForm.subjectIds" :show-all-levels="false" ref="tree" collapse-tags :options="subjectTreeList" :props="subjectTreeProps" clearable></el-cascader>
              </el-form-item>
            </el-col>

            <el-col :sm="5" :md="5" :lg="5">
              <el-form-item label="是否限购" label-width="80px" prop="flashSaleType">
                <el-select v-model="searchForm.flashSaleType" placeholder="请选择" clearable>
                  <el-option value="">全部</el-option>
                  <el-option :label="'是'" :value="'1'"></el-option>
                  <el-option :label="'否'" :value="'-1'"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :sm="8" :md="8" :lg="8">
              <el-form-item label="商品名称">
                <el-input v-model="searchForm.name"></el-input>
              </el-form-item>
            </el-col>
            <el-col :sm="5" :md="5" :lg="5" style="margin-left: 10px">
              <el-button type="primary" @click="getList()">查询</el-button>
            </el-col>
          </el-row>
          <el-row :span="24">
            <el-col :sm="24" :md="24" :lg="24">
              <el-table :data="tableList" ref="multipleTableNew" tooltip-effect="dark" style="width: 100%" @selection-change="handleSelectionChange" :row-key="getRowKey" highlight-current-row border v-loading="loading1" element-loading-text="拼命加载中" element-loading-background="rgba(255, 255, 255, 0.8)" @select="select" @select-all="selectAll">
                <el-table-column type="selection" :reserve-selection="true" width="55">
                </el-table-column>

                <el-table-column prop="name" show-overflow-tooltip label="商品">
                  <template slot-scope="row">
                    <el-row>
                      <el-col :span="8">
                        <span>
                          <img style="margin-right: 10px" width="100%" height="44px" :src="
                            row.row.logo
                              ? row.row.logo
                              : '../../../static/image/noImg.png'
                          " />
                        </span>
                      </el-col>
                      <el-col :span="16">
                        <span style="color: rgb(77, 148, 255); margin-left: 10px">{{ row.row.name }}</span>
                        <span style="display: block; margin-left: 10px">
                          <span style="color: red">￥{{ row.row.price }}</span>
                          <span style="
                              text-decoration: line-through;
                              color: rgb(162, 170, 188);
                            ">￥{{ row.row.originalPrice }}</span>
                        </span>
                      </el-col>
                    </el-row>
                  </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip width="200" prop="agentPrice" label="售价">
                  <template slot-scope="row">
                    <span style="display: block">
                      <span style="color: red">￥{{ row.row.price }}</span>
                      <span style="
                          text-decoration: line-through;
                          color: rgb(162, 170, 188);
                        ">￥{{ row.row.originalPrice }}</span>
                    </span>
                  </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip prop="validDay" width="100" label="有效期">
                  <template slot-scope="row">{{
                      row.row.validDay ? row.row.validDay + '天' : '不限'
                  }}</template>
                </el-table-column>
                <el-table-column show-overflow-tooltip width="200" prop="subjectCourseName" label="所属科目"></el-table-column>
              </el-table>
              <el-pagination background layout="total, prev, pager, next" style="margin-top: 20px; text-align: right" :total="page.total" :page-size="page.pageSize" :current-page="page.pageNumber" @size-change="sizeChange" @current-change="currentChange"></el-pagination>
            </el-col>
          </el-row>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align: right">
        <el-button @click="addFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="closeDialog">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { uploadOSS } from "../../upload/upload";
import draggable from "vuedraggable";
export default {
  components: { draggable },
  data () {
    return {
      clickIdx: 0,
      courseIds: [], //科目
      blockAddGoodsInfo: false,
      subjectTreeList: [], //科目
      subjectTreeProps: {
        value: "id",
        label: "name",
        children: "children",
        multiple:true,
      },
      addForm: {
        name: "",
        subjectId: '',
        seriesList: []
      },
      formLabelWidth: "90px",
      addFormRules: {
        name: [
          {
            required: true,
            message: "请输入系列课名称",
            trigger: "blur",
          },
          {
            min: 1,
            max: 20,
            message: "系列课名称长度在1到100个字",
          },
        ],

      },
      loading1: false,
      addFormVisible: false,
      searchForm: {
        sell: 1,
        name: "",
        subjectIds: [],
      },
      page: {
        total: 0,
        pageSize: 10,
        pageNumber: 1,
        sortName: "",
        sortOrder: "",
      },
      tableList: [],
    };
  },
  watch: {

  },
  methods: {
    subjectChange (val) {
      console.log(val)
    },
    //复选框只能选中一个
    select (selection, row) {
      this.bill_id = row.id;
      // 清除 所有勾选项
      this.$refs.multipleTableNew.clearSelection()
      // 当表格数据都没有被勾选的时候 就返回
      // 主要用于将当前勾选的表格状态清除
      if (selection.length == 0) return
      this.$refs.multipleTableNew.toggleRowSelection(row, true);
    },
    selectAll (selection) {
      if (selection.length > 1) {
        selection.length = 1
      }
    },
    getRowKey (row) {
      return row.id;
    },
    closeDialog () {
      console.log(this.checkList);
      this.checkSureList = this.checkList
      this.itemIndex = "";
      this.addFormVisible = false;
    },
    getList () {
      this.loading1 = true;
      var subArr = []
      this.searchForm.subjectIds.forEach((e) => subArr.push(e[1]));
      console.log('getList', this.searchForm.subjectIds)
      let obj = {
        pageSize: this.page.pageSize,
        pageNumber: this.page.pageNumber,
        sortName: this.page.sortName,
        sortOrder: this.page.sortOrder,
        agentId: this.loginData.agentId,
        flashSaleType: this.searchForm.flashSaleType,
        name: this.searchForm.name,
        subjectIds: subArr,
        sell:1
      };
      this.api.goodsInfo['pageList'](obj).then((result) => {
        this.loading1 = false;
        this.tableList = result.data.records;
        this.page.total = result.data.total;
        this.arrsSelect = [];
      })
    },
    currentChange (pageNumber) {
      this.page.pageNumber = pageNumber;
      this.getList();
    },
    sizeChange (pageSize) {
      this.page.pageSize = pageSize;
      this.getList();
    },

    handleSelectionChange (val) {
      console.log(val)
      this.addForm.seriesList[this.clickIdx].designName = ''
      this.addForm.seriesList[this.clickIdx].name = ''
      this.addForm.seriesList[this.clickIdx].classes = ''
      if (!val || val.length <= 0 || !val[0].name) return false
      if (val && val.length > 0 && val[0].name) {
        let setVal = val[val.length - 1]
        this.$nextTick(() => {
          this.checkList = val;
          this.addForm.seriesList[this.clickIdx].goodsId = setVal.id
          this.addForm.seriesList[this.clickIdx].designName = setVal.name
          this.addForm.seriesList[this.clickIdx].name = setVal.name
          this.addForm.seriesList[this.clickIdx].classes = ''
        })
      } else {
        this.checkList = [{ designName: '', name: '', classes: '', }]
      }
      console.log(val);
      this.addFormVisible = false
    },
    subjectSearchChange (val) {
      // var subArr = []
      // if (this.courseIds) {
      //   val.forEach((e) => subArr.push(e[1]));
      //   this.addForm.subjectId = subArr
      // } else {
      //   this.addForm.subjectId = "";
      // }
      // console.log(val, this.addForm.subjectId)
    },
    getSubjectTreeList () {
      // 获取课程
      this.api.getSubjectTreeList().then((result) => {
        for (let item of result.data) {
          if (item.children.length != 0) {
            for (let items of item.children) {
              delete items.children;
            }
          } else {
          }
        }
        this.subjectTreeList = result.data;
        // this.getGoodsInfo();
      })
    },
    openGoodsModal (idx) {
      console.log('opemodal', idx)
      this.clickIdx = idx
      this.addFormVisible = true
      this.checkList = []
      this.getList()
      setTimeout(() => {
        this.$refs.multipleTableNew.clearSelection()
      }, 500);
    },
    addSeries () {
      this.addForm.seriesList.push({
        designName: '',
        name: '',
        classes: '',
      })
    },
    deleteSeries (idx) {
      this.addForm.seriesList.splice(idx, 1)
    },
    addConfirm () {
      if (this.blockAddGoodsInfo) {
        return false;
      }
      this.blockAddGoodsInfo = true;
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          var newSeriesArr = []
          this.addForm.seriesList.forEach(v => {
            newSeriesArr.push({
              goodsId: v.goodsId,
              courseName: v.name,
              shift: v.classes,
            })
          })
          console.log(newSeriesArr)
          var params = {
            "seriesName": this.addForm.name,
            "goods": newSeriesArr
          }
          var apiName = ''
          if (!this.$route.query.updatePageId) {
            apiName = "addSeriesGoods";
            params.subjectId = this.addForm.subjectId[1]
          } else {
            apiName = 'updateSeriesGoods'
            params.id = this.$route.query.updatePageId
          }
          this.api.goodsInfo[apiName](params).then((result) => {
            if (result.success) {
              this.$router.push({
                path: "/goodsInfo",
                query: {
                  backtoseries: true
                }
              });
            } else {
              this.blockAddGoodsInfo = false;
              this.$message.error(result.message);
            }
          })
        } else {
          this.blockAddGoodsInfo = false;
          return false;
        }
      });
    },
    getSeriesGoodsData () {
      var that = this
      this.api.goodsInfo.getSeriesGoods({ id: this.$route.query.updatePageId }).then(res => {
        if (res.code == '200') {
          this.addForm.name = res.data.seriesName
          this.addForm.subjectId = res.data.subjectId
          if (res.data.goods && res.data.goods.length > 0) {
            that.addForm.seriesList = []
            res.data.goods.forEach((v, k) => {
              that.addForm.seriesList.push({
                goodsId: v.goodsId,
                designName: v.goodsName,
                name: v.courseName,
                classes: v.shift,
              })
            })
          }
          console.log(this.addForm.seriesList, ' this.addForm.seriesList')
          this.subjectTreeList.forEach((element) => {
            if (element.children) {
              element.children.forEach((elements) => {
                console.log(123, this.addForm.subjectId);
                if (elements.id == this.addForm.subjectId) {
                  this.courseIds = [element.id, elements.id];
                  // this.courseIds.push(element.id);
                  // this.courseIds.push(elements.id);
                }
              });
            }
          });
        }
      })
    },
  },
  computed: {
    ...mapGetters(["loginData"]),
  },
  mounted () {
    if (this.$route.query.updatePageId) {
      this.getSeriesGoodsData()
    }
    this.getSubjectTreeList()
  },
};
</script>
<style lang="less" scoped>
.seriesClass .el-input {
  width: 93%;
}

.btnCenter {
  display: flex;
  justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/components/goods/addSeriesGoods.vue